import API, { Endpoints } from "services/api";
import type { UIMessage } from "ai";

const base = () => Endpoints.conversations;

export interface ConversationSummary {
    conversationId: string;
    dataSetId: string;
    title?: string;
    messageCount?: number;
    lastMessagePreview?: string;
    createdDate?: string;
    updatedDate?: string;
}

export async function listConversations(dataSetId: string): Promise<ConversationSummary[]> {
    const api = new API();
    const result = await api.get(`${base()}/api/v1/datasets/${dataSetId}/conversations`);
    return result?.data?.Items ?? [];
}

export async function createConversation(dataSetId: string, title?: string): Promise<ConversationSummary> {
    const api = new API();
    const result = await api.post(`${base()}/api/v1/datasets/${dataSetId}/conversations`, { title });
    return result?.data;
}

export async function getConversationMessages(conversationId: string): Promise<UIMessage[]> {
    const api = new API();
    const result = await api.get(`${base()}/api/v1/conversations/${conversationId}`);
    return (result?.data?.messages ?? []) as UIMessage[];
}

export async function saveConversationMessages(
    dataSetId: string,
    conversationId: string,
    messages: UIMessage[],
): Promise<void> {
    const api = new API();
    await api.post(`${base()}/api/v1/datasets/${dataSetId}/conversations/${conversationId}/messages`, { messages });
}

export async function deleteConversation(dataSetId: string, conversationId: string): Promise<void> {
    const api = new API();
    await api.delete(`${base()}/api/v1/datasets/${dataSetId}/conversations/${conversationId}`, null);
}